import { render, staticRenderFns } from "./CaretUp.vue?vue&type=template&id=b5f8555c&"
import script from "./CaretUp.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaretUp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports